import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import {
  getPlanList,
  getQuizDetails,
  getQuizSeriesList,
  getQuizSeriesOverview,
  showProgress,
} from '../../../redux/actions/DealershipActions';
import { ErrorToast } from '../../utils/Utils';

const useFetchData = () => {
  const dispatch = useDispatch();
  const [seriesDetails, setSeriesDetails] = useState([]);
  const [partners, setPartners] = useState([]);

  const getRnp = useCallback(async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.CERT_RNP_LIST);
      setPartners(res);
    } catch (error) {
      ErrorToast(error);
    } finally {
      dispatch(showProgress(false));
    }
  }, [dispatch]);

  const fetchPlans = useCallback(async () => {
    dispatch(showProgress(true));
    const payload = '';
    await service
      .get(apiEndpoints.GET_PLANS, payload)
      .then((response) => {
        dispatch(getPlanList('fetch', response));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  }, [dispatch]);

  const fetchQuizDetails = useCallback(
    async (id) => {
      dispatch(showProgress(true));
      try {
        const res = await service.get(apiEndpoints.QUIZ_DETAILS.replace('ID', id));
        dispatch(getQuizDetails(res, id));
      } catch (err) {
        ErrorToast(err);
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );
  const fetchQuizSeriesOveview = useCallback(
    async (id) => {
      dispatch(showProgress(true));
      try {
        const res = await service.get(apiEndpoints.QUIZ_SERIES_OVERVIEW.replace('ID', id));
        dispatch(getQuizSeriesOverview(res, id));
      } catch (err) {
        ErrorToast(err);
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );

  const fetchQuizSeriesDetails = useCallback(
    async (id) => {
      dispatch(showProgress(true));
      try {
        const res = await service.get(apiEndpoints.QUIZ_SERIES_DETAILS.replace('ID', id));
        setSeriesDetails(res);
      } catch (err) {
        ErrorToast(err);
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );

  const fetchQuizSeriesList = useCallback(
    async (id, initial = true) => {
      dispatch(showProgress(true));
      try {
        const res = await service.get(apiEndpoints.QUIZ_SERIES_FETCH);
        dispatch(getQuizSeriesList(res));
        if (initial && res[0]?.id) {
          fetchQuizSeriesOveview(res[0]?.id);
        } else {
          fetchQuizSeriesOveview(id);
        }
      } catch (err) {
        ErrorToast(err);
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch, fetchQuizSeriesOveview],
  );
  return {
    seriesDetails,
    partners,
    getRnp,
    fetchQuizSeriesList,
    fetchQuizSeriesOveview,
    fetchQuizDetails,
    fetchPlans,
    fetchQuizSeriesDetails,
  };
};
export default useFetchData;
